module.exports = __webpack_public_path__ + "img/menu_create.74b207ac.svg";